<template>
  <div>
    <!-- List Table -->
    <List
      :header="header"
      :data="data"
      :pagination="pagination"
      :loading="loading"
      @updatePage="updatePage"
    >
    </List>

    <b-button
      type="button"
      @click="showDetail = true"
      variant="primary"
      class="px-10 mt-5"
      >{{ $t('servers.takeSnapshot') }}</b-button
    >

    <!-- Create Popup -->
    <DetailModal
      :title="$t('servers.takeSnapshot')"
      :show="showDetail"
      @confirm="confirmModal()"
      @closeDetail="closeDetail()"
      :resetForm="resetForm"
    >
      <TakeSnapshot
        :confirmModal="confirmCreate"
        @resetDetailForm="resetDetailForm"
        :total_disk="vmData.total_disk"
        :vmData="vmData"
      />
    </DetailModal>
  </div>
</template>

<script>
// Utils
import ApiService from '@/core/services/api.service'

export default {
  name: 'AvaibleSnapshots',
  data() {
    return {
      vmData: '',
      showDetail: false,
      confirmCreate: false,
      resetForm: false,
      loading: false,
      header: [
        { text: 'global.name', value: 'name' },
        { text: 'global.cPU', value: 'total_cpu' },
        { text: 'global.ram', value: 'total_ram' },
        { text: 'global.hardDisk', value: 'total_disk' },
      ],
      data: [],
      pagination: {},
      meta: {},
    }
  },
  props: {
    vmId: {
      type: String,
      default: '',
    },
  },
  computed: {
    getVmId() {
      return this.vmId ? this.vmId : this.$route.params.id
    },
  },
  created() {
    this.getList()
    this.getDetail()
  },
  methods: {
    getList() {
      this.loading = true

      const { current_page } = this.meta

      let $query = `iaas/virtual-machines/${
        this.getVmId
      }/snapshots?position=id|desc&page=${current_page ? current_page : 1}`

      ApiService.get($query)
        .then(({ data }) => {
          this.data = data.data
          this.pagination = data.meta ? data.meta.pagination : {}

          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.data = []
          this.loading = false
        })
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    getDetail() {
      this.getDetailInfo().then((res) => {
        this.vmData = res.data
      })
    },
    getDetailInfo() {
      return new Promise((resolve, reject) => {
        ApiService.get(
          `iaas/virtual-machines/${this.getVmId}?include=datacenterNode`
        )
          .then(({ data }) => {
            resolve(data)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    closeDetail() {
      this.showDetail = false
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetDetailForm(closeDetail = false) {
      if (closeDetail) {
        this.$generateToast(this, 'success', this.$t('global.successful'))
        this.closeDetail()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: {
    TakeSnapshot: () =>
      import('@/components/compute/virtualMachines/actions/TakeSnapshot'),
  },
}
</script>
